import {Injectable} from '@angular/core';
import {KundeEntitiesEffects} from './kunde-entities.effects';
import {KontaktActions} from '../actions/kontakt.actions';


@Injectable()
export class KontaktEffects {

  constructor(
    private kundeEntitiesEffects: KundeEntitiesEffects,
  ) {
  }

  readonly readKunden$ = this.kundeEntitiesEffects.readKunden$(
    KontaktActions.readKunden,
    KontaktActions.setDisplayedIds,
    KontaktActions.clearDisplayedKunden,
  );

  readonly readMoreKunden$ = this.kundeEntitiesEffects.readKunden$(
    KontaktActions.readMoreKunden,
    KontaktActions.addDisplayedIds,
    KontaktActions.clearDisplayedKunden,
  );

}
